import { CarProvider } from './components/Context/CarContext';
import { PartnerProvider } from './components/Context/PartnerContext';
import { SnackbarProvider } from './views/SnackBar';
import AppRoutes from './routes';
import { ServiceProvider } from './components/Context/ServiceContext';
import { BranchProvider } from './components/Context/BranchContext';
import { UserProvider } from './components/Context/userContext';
import { DashboardProvider } from './components/Context/DashboardContext';
import { OrderProvider } from './components/Context/OrderContext';
import { ProgressBarProvider } from './views/ProgressBar';
import { ToastContainer } from "react-toastify";
import { TranslationProvider, TranslationContext } from './components/Context/TranslationContext';
import { useContext } from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import stylisRTLPlugin from 'stylis-plugin-rtl';

const stylisPlugins = [stylisRTLPlugin];
console.log(stylisPlugins); // Ensure this logs `[function stylisRTLPlugin]`

const rtlCache = createCache({
    key: 'muirtl',
    stylisPlugins,
});
function AppContent() {
    const { isRTL } = useContext(TranslationContext); // Now inside TranslationProvider
    const theme = createTheme({
        direction: isRTL === true ? 'rtl' : 'ltr',
    });

    return (
  <div style={{ direction: isRTL===true ? 'rtl' : 'ltr' }}>
        {/*<CacheProvider value={rtlCache}>*/}
        {/*    <ThemeProvider theme={theme}>*/}
                <ToastContainer />
                <ProgressBarProvider>
                    <DashboardProvider>
                        <UserProvider>
                            <SnackbarProvider>
                                <CarProvider>
                                    <PartnerProvider>
                                        <BranchProvider>
                                            <ServiceProvider>
                                                <OrderProvider>
                                                    <AppRoutes />
                                                </OrderProvider>
                                            </ServiceProvider>
                                        </BranchProvider>
                                    </PartnerProvider>
                                </CarProvider>
                            </SnackbarProvider>
                        </UserProvider>
                    </DashboardProvider>
                </ProgressBarProvider>
            {/*</ThemeProvider>*/}
            {/*</CacheProvider>*/}
        </div>
    );
}

export default function MyApp() {
    return (
        <TranslationProvider>
            <AppContent />
        </TranslationProvider>
    );
}
